<div class="py-1"></div>
<div class="card">
  <h6 class="card-header" style="cursor: pointer" (click)="showNewEmailAddressForm = !showNewEmailAddressForm"><i class="fas" [ngClass]="{ 'fa-plus-circle': !showNewEmailAddressForm, 'fa-minus-circle': showNewEmailAddressForm }"></i>&nbsp;New Email Address</h6>
  <div class="card-body" [hidden]="!showNewEmailAddressForm" style="max-height: 340px; overflow-y: scroll">
    <app-email-address-form [contactId]="contactId" (saved)="formSaved($event)"></app-email-address-form>
  </div>
</div>
<div class="py-1"></div>
<div class="float-right">
  <button type="button" [disabled]="loadingEmailAddresses" (click)="loadEmailAddresses()" class="btn btn-outline-primary btn-sm">
    <i class="fas fa-redo fa-fw" [ngClass]="{ 'fa-spin': loadingEmailAddresses }"></i>
  </button>
</div>
<div class="clearfix"></div>
<div class="py-1"></div>
<table class="table table-sm">
  <tbody  [appNativeSortableJs]="emailAddresses" [sortableOptions]="sortableOptions">
    <tr *ngFor="let emailAddress of emailAddresses; let i = index">
      <td *ngIf="!emailAddress.editing" [title]="emailAddress.notes">
        <div class="alias-sort-handle d-inline-block py-1 px-2" style="cursor: grab" title="Sort">
          <i class="fas fa-random"></i>
        </div>
        {{ emailAddress.email }}
        <span *ngIf="emailAddress.notes">
          <br />
          <i class="text-muted">{{ emailAddress.notes }}</i>
        </span>
      </td>
      <td *ngIf="!emailAddress.editing">
        <div class="btn-group btn-sm">
          <a title="Edit" href="#" (click)="$event.preventDefault(); emailAddress.editing = true" class="btn btn-outline-primary btn-sm">
            <i class="fas fa-pencil-alt"></i>
          </a>
          <a title="Delete" href="#" (click)="$event.preventDefault(); deleteEmailAddress(emailAddress, i)" class="btn btn-outline-danger btn-sm">
            <i class="fas fa-trash"></i>
          </a>
        </div>
      </td>
      <td colspan="3" *ngIf="emailAddress.editing">
        <h6 class="font-italic text-info">Editing Email Address</h6>
        <app-email-address-form [emailAddress]="emailAddress" (saved)="formSaved($event, emailAddress)"></app-email-address-form>
      </td>
    </tr>
  </tbody>
</table>
<div class="py-1"></div>
<div class="card" *ngIf="isUser">
  <h6 class="card-header" style="cursor: pointer" (click)="showBlacklists = !showBlacklists; showBlacklists ? loadBlacklists() : ''"><i class="fas" [ngClass]="{ 'fa-plus-circle': !showBlacklists, 'fa-minus-circle': showBlacklists }"></i>&nbsp;Blacklist</h6>
  <div class="card-body" [hidden]="!showBlacklists" style="max-height: 340px; overflow-y: scroll">
    <div class="card">
      <h6 class="card-header p-2" style="cursor: pointer" (click)="showNewBlacklistForm = !showNewBlacklistForm"><i class="fas" [ngClass]="{ 'fa-plus-circle': !showNewBlacklistForm, 'fa-minus-circle': showNewBlacklistForm }"></i>&nbsp;Add New Email</h6>
      <div class="card-body p-2" [hidden]="!showNewBlacklistForm" style="max-height: 340px; overflow-y: scroll">
        <form novalidate #currentBlacklistForm="ngForm">
          <div class="form-group">
            <label>Email</label>
            <input type="text" required class="form-control form-control-sm" name="email" [(ngModel)]="newBlacklist.value" />
          </div>
          <div class="form-group">
            <label>Description</label>
            <input type="text" class="form-control form-control-sm" name="email" [(ngModel)]="newBlacklist.descript" />
          </div>
          <div class="form-row">
            <div class="col-6">
              <button type="button" class="btn btn-primary btn-sm btn-block" [disabled]="savingBlacklist" (click)="createBlacklist()">Save</button>
            </div>
            <div class="col-6">
              <button type="button" class="btn btn-outline-secondary btn-sm btn-block" [disabled]="savingBlacklist" (click)="newBlacklist = {}; showNewBlacklistForm = false">Cancel</button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="py-1"></div>
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <button type="button" *ngIf="selectedBlacklist.size > 0" [disabled]="deletingBlacklist" (click)="bulkDeleteBlacklist()" class="btn btn-danger btn-sm">
          <i class="fas fa-trash"></i> Delete Selected ({{ selectedBlacklist.size }})
        </button>
      </div>
      <button type="button" [disabled]="loadingBlacklists" (click)="loadBlacklists()" class="btn btn-outline-primary btn-sm">
        <i class="fas fa-redo fa-fw" [ngClass]="{ 'fa-spin': loadingBlacklists }"></i>
      </button>
    </div>
    <div class="py-1"></div>
    <table class="table table-sm">
      <thead *ngIf="blacklistEmails.length > 0">
        <tr>
          <th style="width: 30px">
            <input type="checkbox" [checked]="selectedBlacklist.size === blacklistEmails.length && blacklistEmails.length > 0" (change)="toggleAllBlacklist()" title="Select All" />
          </th>
          <th style="width: 50px"></th>
          <th>Email</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let blacklistEmail of blacklistEmails; let i = index">
          <td>
            <input type="checkbox" [checked]="selectedBlacklist.has(blacklistEmail)" (change)="toggleBlacklistSelection(blacklistEmail)" />
          </td>
          <td>
            <button title="Remove Email" [disabled]="deletingBlacklist" (click)="deleteBlacklistedEmail(blacklistEmail, i)" class="btn btn-outline-danger btn-sm">
              <i class="fas fa-trash"></i>
            </button>
          </td>
          <td>{{ blacklistEmail }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<div class="py-1" *ngIf="isUser"></div>
<div class="card" *ngIf="isUser">
  <h6 class="card-header" style="cursor: pointer" (click)="showWhitelists = !showWhitelists; showWhitelists ? loadWhitelists() : ''"><i class="fas" [ngClass]="{ 'fa-plus-circle': !showWhitelists, 'fa-minus-circle': showWhitelists }"></i>&nbsp;Whitelist</h6>
  <div class="card-body" [hidden]="!showWhitelists" style="max-height: 340px; overflow-y: scroll">
    <div class="card">
      <h6 class="card-header p-2" style="cursor: pointer" (click)="showNewWhitelistForm = !showNewWhitelistForm"><i class="fas" [ngClass]="{ 'fa-plus-circle': !showNewWhitelistForm, 'fa-minus-circle': showNewWhitelistForm }"></i>&nbsp;Add New Email</h6>
      <div class="card-body p-2" [hidden]="!showNewWhitelistForm" style="max-height: 340px; overflow-y: scroll">
        <form novalidate #currentWhitelistForm="ngForm">
          <div class="form-group">
            <label>Email</label>
            <input type="text" required class="form-control form-control-sm" name="email" [(ngModel)]="newWhitelist.value" />
          </div>
          <div class="form-group">
            <label>Description</label>
            <input type="text" class="form-control form-control-sm" name="email" [(ngModel)]="newWhitelist.descript" />
          </div>
          <div class="form-row">
            <div class="col-6">
              <button type="button" class="btn btn-primary btn-sm btn-block" [disabled]="savingWhitelist" (click)="createWhitelist()">Save</button>
            </div>
            <div class="col-6">
              <button type="button" class="btn btn-outline-secondary btn-sm btn-block" [disabled]="savingWhitelist" (click)="newWhitelist = {}; showNewWhitelistForm = false">Cancel</button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="py-1"></div>
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <button type="button" *ngIf="selectedWhitelist.size > 0" [disabled]="deletingWhitelist" (click)="bulkDeleteWhitelist()" class="btn btn-danger btn-sm">
          <i class="fas fa-trash"></i> Delete Selected ({{ selectedWhitelist.size }})
        </button>
      </div>
      <button type="button" [disabled]="loadingWhitelists" (click)="loadWhitelists()" class="btn btn-outline-primary btn-sm">
        <i class="fas fa-redo fa-fw" [ngClass]="{ 'fa-spin': loadingWhitelists }"></i>
      </button>
    </div>
    <div class="py-1"></div>
    <table class="table table-sm">
      <thead *ngIf="whitelistEmails.length > 0">
        <tr>
          <th style="width: 30px">
            <input type="checkbox" [checked]="selectedWhitelist.size === whitelistEmails.length && whitelistEmails.length > 0" (change)="toggleAllWhitelist()" title="Select All" />
          </th>
          <th style="width: 50px"></th>
          <th>Email</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let whitelistEmail of whitelistEmails; let i = index">
          <td>
            <input type="checkbox" [checked]="selectedWhitelist.has(whitelistEmail)" (change)="toggleWhitelistSelection(whitelistEmail)" />
          </td>
          <td>
            <button title="Remove Email" [disabled]="deletingWhitelist" (click)="deleteWhitelistedEmail(whitelistEmail, i)" class="btn btn-outline-danger btn-sm">
              <i class="fas fa-trash"></i>
            </button>
          </td>
          <td>{{ whitelistEmail }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
